import { useState } from 'react';
import '../css/TireModuleContent.css';

interface SelectWithCustomProps {
    value: string;
    onChange: (value: string) => void;
    options: string[];
    placeholder?: string;
    className?: string;
}

const CUSTOM_KEY = '__custom__';

export const SelectWithCustom = ({
    value,
    onChange,
    options,
    placeholder = 'Select...',
    className = 'add-tire-select',
}: SelectWithCustomProps) => {
    const isCustom = value !== '' && !options.includes(value);
    const [showCustomInput, setShowCustomInput] = useState(isCustom);

    const handleSelectChange = (val: string) => {
        if (val === CUSTOM_KEY) {
            setShowCustomInput(true);
            onChange('');
        } else {
            setShowCustomInput(false);
            onChange(val);
        }
    };

    if (showCustomInput) {
        return (
            <div className="select-custom-wrap">
                <input
                    className="add-tire-input"
                    placeholder="Type custom value..."
                    value={value}
                    onChange={e => onChange(e.target.value)}
                    autoFocus
                />
                <button
                    type="button"
                    className="select-custom-back"
                    onClick={() => { setShowCustomInput(false); onChange(''); }}
                    title="Back to list"
                >
                    ←
                </button>
            </div>
        );
    }

    return (
        <select
            className={className}
            value={value}
            onChange={e => handleSelectChange(e.target.value)}
        >
            <option value="">{placeholder}</option>
            {options.map(opt => (
                <option key={opt} value={opt}>{opt}</option>
            ))}
            <option value={CUSTOM_KEY}>Other (custom)...</option>
        </select>
    );
};
